import { CircularProgress } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { db } from "../../../firebase";
import MemberCard from "../../Atoms/Card/commiteeMemberCard/MemberCard";
import "./members.css";

import MembersForm from "./MembersForm";

function CommunityMembers() {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(!false);
  const [members, setMembers] = useState([]);
  const [reRender, setReRender] = useState(false);

  useEffect(() => {
    setMembers([]);
    setLoading(true);
    const fetchData = async () => {
      try {
        const snapshot = await db
          .collection("Committee")
          .orderBy("priority", "asc")
          .get();
        snapshot.forEach((doc) => setMembers((prev) => [...prev, doc.data()]));
        setLoading(false);
        // console.log(members);
      } catch (e) {
        console.log(e);
        setLoading(false);
      }
    };
    fetchData();
  }, [reRender]);

  return (
    <>
      <div className="members">
        <div
          className="members__addNew"
          onClick={() => setShowModal(true)}
          style={{
            background: "linear-gradient(135deg, #fad961 0%, #f76b1c 100%)",
          }}
        >
          <Add
            style={{
              fontSize: "150px",
              color: "white",
            }}
          />
        </div>
        {loading ? (
          <div className="loading__center">
            <CircularProgress style={{ height: 100, width: 100 }} />
          </div>
        ) : (
          members.map((item) => (
            <MemberCard key={item.key} data={item} setReRender={setReRender} />
          ))
        )}
      </div>
      <MembersForm
        state={[showModal, setShowModal]}
        setReRender={setReRender}
      />
    </>
  );
}

export default CommunityMembers;
